export default __webpack_public_path__ + "static/media/BS.094bce2a.svg";